import { error, tabaPayError } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const UpdateExternalCardExpiryDate = gql`
  mutation UpdateExternalCardExpiryDate(
    $input: UpdateExternalCardExpiryDateInput!
  ) {
    updateExternalCardExpiryDate(input: $input) {
      ... on UpdateExternalCardExpiryDateResultSuccess {
        success
        __typename
      }
      ... on UpdateExternalCardExpiryDateResultError {
        ...error
        __typename
      }
      ... on TabaPayCustomError {
        ...tabaPayError
        __typename
      }
    }
  }
  ${error}
  ${tabaPayError}
`;
